interface IConfig {
    MODE: 'DEV' | 'TEST' | 'PROD';
    CRM_BACKEND_URL: string;
}

const config: IConfig = {
    MODE: String(process.env.REACT_APP_MODE) as IConfig['MODE'],
    CRM_BACKEND_URL: String(process.env.REACT_APP_CRM_BACKEND_URL ?? ''),
};

export default config;
